import { useParams } from 'react-router-dom'

import {
  Bar,
  LoadingContainer,
  ModelList,
  Pagination,
  Panels,
} from 'peach/components'

import { useQueryString } from 'core/hooks'
import { Page } from 'core/components'
import { PickRequired, useInteractionGetAll } from 'core/types'
import { InteractionGetAllVariables } from 'core/types/operations'

const PersonInteractions = () => {
  const { personId } = useParams<{ personId?: string }>()

  const [query, setQuery] = useQueryString<
    PickRequired<
      NonNullable<InteractionGetAllVariables['query']>,
      'limit' | 'offset'
    >
  >({
    limit: 50,
    offset: 0,
  })

  const {
    data: interactions,
    pagination: { total: count } = {},
    isLoading,
    error,
    isFetching,
  } = useInteractionGetAll({ personId, query })

  return (
    <Panels
      header={
        <Bar
          left={
            <Pagination
              limit={query.limit ?? 0}
              maxPagesVisible={16}
              offset={query.offset ?? 0}
              onChange={(offset) => setQuery({ offset })}
              total={count}
            />
          }
          title='Interactions'
        />
      }
    >
      <LoadingContainer error={error} loading={isLoading || isFetching}>
        <Page variant='full'>
          <ModelList json={interactions ?? []} title='Interactions' />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default PersonInteractions
